<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Fecha Entrega"
          label-for="fechaEntrega"
          :labelCols="labelCols"
          :description="descripcion">
          <b-input-group>
            <b-form-input 
              id="fechaEntrega" 
              v-model="fechaEntrega" 
              type="date"
              :state="fechaEntregaValida">
            </b-form-input>
          </b-input-group>
          <b-form-invalid-feedback id="fechaEntregaFeedback">
            {{ fechaEntregaInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          v-if="!entregaEstimada"
          :label-cols="labelCols"
          horizontal>
          <b-form-checkbox 
              id="actualizarEstado"
              v-model="actualizarEstado"
              :value="true"
              :unchecked-value="false">
              Actualizar Estado (Entregado)
          </b-form-checkbox>
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Actualizar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment';

export default {
  name: 'RemitosActualizacionEntrega',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
    remitoId: {
      type: Number,
      default: 0
    },
    remitos: {
      type: Array,
      default: null
    },
    entregaEstimada: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      fechaEntrega: moment(new Date()).format('YYYY-MM-DD'),
      actualizarEstado: false,

      fechaEntregaValida: null,
      fechaEntregaInvalidaMsj: '',
      descripcion: '',

      labelCols: 2,
    }
  },
  created() {
    if ((/true/i).test(this.entregaEstimada)) {
      this.descripcion="Fecha de Entrega Estimada"
    }
  },  
  methods: {
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      let save = true;

      if (this.remitoId == 0) {
        let errorRemitos = true;
        if (this.remitos) {
          errorRemitos = this.remitos.length == 0;
        }
        if (errorRemitos) {
          this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de remitos a actualizar'))
          save = false;
        }
      }


      if (save) {
        this.showSpinner();
        let params = {
          remitoId: this.remitoId,
          remitos: this.remitos,
          entregaEstimada: this.entregaEstimada
        };

        if ((/true/i).test(this.entregaEstimada)) {
          params.fechaEntregaEstimada = this.fechaEntrega;
        } else {
          params.fechaEntrega = this.fechaEntrega;
          params.actualizarEstado = this.actualizarEstado;
        }

        let msj = 'La información del remito se actualizó con éxito';
        if (this.remitoId == 0) {
          msj = 'La información de los remitos seleccionados se actualizó con éxito';
        }
        this.$store.dispatch('remito/actualizarEntrega', params)
          .then(() => this.showModalMsj(msj, this.close.bind(this, true), this.close.bind(this, true), 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },

    cancelar() {
      this.close(false);
    },
    close(actualizado) {
      this.$emit('close', actualizado);
    }
  },
  validations: {
  },  
}
</script>

<style>
</style>
